import { render, staticRenderFns } from "./FlyingView.vue?vue&type=template&id=c831a6c2"
import script from "./FlyingView.vue?vue&type=script&lang=js"
export * from "./FlyingView.vue?vue&type=script&lang=js"
import style0 from "./FlyingView.vue?vue&type=style&index=0&id=c831a6c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports